/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: measure-unit-utils.ts
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1745
 * ---
 */

import {MeasureUnits} from './enums';

/**
 * Converte in pixel un valore in una delle unità di misura supportate.
 * @param {MeasureUnits} measureUnit
 * @param {number} measureValue
 * @returns {number}
 */
export const measureUnitToPixel = (measureUnit: MeasureUnits, measureValue: number) => {
  switch (measureUnit) {
    case MeasureUnits.MM:
      return Math.round(parseFloat((measureValue * 3.7795275591).toFixed(2)));

    case MeasureUnits.CM:
      return Math.round(parseFloat((measureValue * 37.795275591).toFixed(2)));

    case MeasureUnits.INCH:
      return Math.round(parseFloat((measureValue * 96).toFixed(2)));

    case MeasureUnits.PX:
      return measureValue;

    default:
      throw new Error(`Unità di misura ${ measureUnit } non supportata`);
  }
};

/**
 * Converte in una delle unità di misura supportate un valore in pixel.
 * @param {MeasureUnits} measureUnit
 * @param {number} pixelValue
 * @returns {number}
 */
export const pixelToMeasureUnit = (measureUnit: MeasureUnits, pixelValue: number) => {
  switch (measureUnit.toLowerCase()) {
    case MeasureUnits.MM:
      return Math.round(parseFloat((pixelValue * 0.2645833333).toFixed(2)));

    case MeasureUnits.CM:
      return Math.round(parseFloat((pixelValue * 0.0264583333).toFixed(2)));

    case MeasureUnits.INCH:
      return Math.round(parseFloat((pixelValue * 0.0104166667).toFixed(2)));

    case MeasureUnits.PX:
      return pixelValue;

    default:
      throw new Error(`Unità di misura ${ measureUnit } non supportata`);
  }
};

/**
 * Wrapper dei metodi da e verso pixel, converte in qualsiasi
 * delle unità di misura supportate un valore in una qualsiasi delle stesse.
 * @param {MeasureUnits} inputMeasureUnit
 * @param {MeasureUnits} outputMeasureUnit
 * @param {number} measureValue
 * @returns {number}
 */
export const measureUnitToMeasureUnit = (inputMeasureUnit: MeasureUnits, outputMeasureUnit: MeasureUnits, measureValue: number) => {
  switch (outputMeasureUnit) {
    case MeasureUnits.MM:
      return Math.round(parseFloat((measureUnitToPixel(inputMeasureUnit,
        measureValue) * 0.2645833333).toFixed(2)));

    case MeasureUnits.CM:
      return Math.round(parseFloat(measureUnitToPixel(inputMeasureUnit,
        measureValue * 0.0264583333).toFixed(2)));

    case MeasureUnits.INCH:
      return Math.round(parseFloat(measureUnitToPixel(inputMeasureUnit,
        measureValue * 0.0104166667).toFixed(2)));

    case MeasureUnits.PX:
      return Math.round(Math.ceil(measureUnitToPixel(inputMeasureUnit,
        measureValue)));

    default:
      throw new Error(`Unità di misura ${ inputMeasureUnit } non supportata`);
  }
};
